let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6hgQv")).then(() => parcelRequire('8MiMS'));